var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", _vm._b({}, "Card", _vm.options, false), [
    _c("div", { staticClass: "list__conatainer" }, [
      _c(
        "ul",
        _vm._l(_vm.actions, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "item__action",
              class: { "not-avaible": !item.avaible },
              on: {
                click: function($event) {
                  return _vm.selected(item)
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "item__icon" },
                [
                  _c(
                    "Icon",
                    _vm._b(
                      {
                        attrs: {
                          color: "#ffffff",
                          icon: item.icon ? item.icon : "decisionTree"
                        }
                      },
                      "Icon",
                      item.size ? item.size : null,
                      false
                    )
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "action__name" }, [
                _vm._v(_vm._s(item.name))
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("span", { staticClass: "list__arrow" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cda765f0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cda765f0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/sections/Actions.vue
// module id = null
// module chunks = 